import React, { useState } from 'react'
import { Modal, Row, Col, Input, Button, message } from 'antd';
import { genVRoomToken } from '../../helpers'
import { useSelector, useDispatch } from 'react-redux'
import { translate } from 'react-i18next'
import { checkTokenExpire } from '../../redux/actions/actions'

const ModalJoinVroom = ({ visible, title, setJointVroom, t }) => {
    const [room, setRoom] = useState('')
    const dispatch = useDispatch()
    const keycloak = useSelector(state => state.keycloak)
    const handleCancel = () => {
        setJointVroom(false)
    };

    const onReservationByLogin = async () => {
        dispatch(checkTokenExpire)
        if (room !== '') {
            const vRoomToken = await genVRoomToken(keycloak)
            window.location.href = `${window._env_.vRoomUrl}/${room}?jwt=${vRoomToken}`
        } else {
            message.error('กรุณาระบุชื่อห้อง!!!')
        }
    }

    const onSetRoom = (input) => {
        setRoom(input.target.value)
    }
    return (
        <>
            <Modal
                title={title}
                visible={visible}
                onCancel={handleCancel}
                footer={[
                    <Button key="submit" className="btn-submit-join-vroom" onClick={onReservationByLogin}>
                        {t("reservation_modal_join.OK")}
                    </Button>,
                    <Button key="back" className="btn-cancel-join-vroom" onClick={handleCancel}>
                        {t("reservation_modal_join.cancel")}
                    </Button>
                ]}
            >
                <Row className="modal-input-join-vroom">
                    <Col span={24}>
                        <div className="join-v-room-name-input">
                            <Input type="text" placeholder={t("reservation_modal_join.input")} onChange={onSetRoom} value={room} className="join-vroom-input" id="join-v-room-name-input" />
                        </div>
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

export default translate()(ModalJoinVroom)
